import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-companies-agreement-dialog',
  templateUrl: './companies-agreement-dialog.component.html',
  styleUrls: ['./companies-agreement-dialog.component.scss'],
})
export class CompaniesAgreementDialogComponent {
  company_id: string;
  company_agreement: string;
  is_list_running: boolean = false;
  company_agreement_list: string[] = [];
  set_agreement_form_group: FormGroup = this.form_service.set_agreement_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_company_edit_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesAgreementDialogComponent>,
    private form_service: FormService,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company_id = data.company_id;
    this.company_agreement = data.agreement;
  }

  ngOnInit(): void {
    this.listCompanyAgreements();
    this.set_agreement_form_group.get(this.form_service.agreement_label)?.setValue(this.company_agreement);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid()) {
      const agreement = this.set_agreement_form_group.get(this.form_service.agreement_label)?.value;
      this.setAgreement(this.company_id, agreement);
    }
  }

  setAgreement(company_id: string, agreement: string): void {
    this.is_company_edit_running = true;
    this.companies_service.setAgreement(company_id, agreement).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_company_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_company_edit_running = false;
      },
    });
  }

  listCompanyAgreements(): void {
    this.is_list_running = true;
    this.companies_service.listCompanyAgreements().subscribe({
      next: response => {
        console.log(response);
        this.company_agreement_list = response.data.data;
        this.is_list_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_list_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.set_agreement_form_group);
  }
}
